import { Phone, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4" data-testid="footer-company-name">Maruns Limited</h3>
            <p className="text-gray-400 mb-4">
              Professional logistics and transport services across the UK. Licensed operations with a rapidly growing team of skilled professionals specializing in residential, commercial, food service, clearance, and technology logistics.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" data-testid="footer-link-home" className="text-gray-400 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" data-testid="footer-link-about" className="text-gray-400 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" data-testid="footer-link-services" className="text-gray-400 hover:text-white transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/careers" data-testid="footer-link-careers" className="text-gray-400 hover:text-white transition-colors">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/contact" data-testid="footer-link-contact" className="text-gray-400 hover:text-white transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-blue-400 flex-shrink-0 mt-1" />
                <div>
                  <p className="text-gray-400 text-sm">
                    Innovation Centre and Business Base<br />
                    110 Butterfield, Great Marlings<br />
                    Luton, LU2 8DL<br />
                    United Kingdom
                  </p>
                </div>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-blue-400" />
                <a href="tel:+447405747177" data-testid="footer-phone" className="text-gray-400 hover:text-white transition-colors">
                  +44 7405 747177
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-blue-400" />
                <a href="mailto:marunsltd@outlook.com" data-testid="footer-email" className="text-gray-400 hover:text-white transition-colors">
                  marunsltd@outlook.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-center items-center gap-4 mb-6">
            <Link to="/privacy-policy" data-testid="footer-link-privacy" className="text-gray-400 hover:text-white transition-colors text-sm">
              Privacy Policy
            </Link>
            <span className="hidden md:inline text-gray-600">|</span>
            <Link to="/terms" data-testid="footer-link-terms" className="text-gray-400 hover:text-white transition-colors text-sm">
              Terms & Conditions
            </Link>
          </div>
          <div className="text-center text-gray-400 space-y-2">
            <p className="font-semibold text-white">Maruns Limited</p>
            <p className="text-sm">Company Number: 16749241</p>
            <p className="text-sm">Registered in England & Wales</p>
            <p className="text-sm">
              Registered Office: Innovation Centre and Business Base, 110 Butterfield, Great Marlings, Luton, LU2 8DL, United Kingdom
            </p>
            <p className="text-sm mt-4" data-testid="footer-copyright">
              &copy; {new Date().getFullYear()} Maruns Limited. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;